/**
 * Blocos das fichas de detalhe (visual v2): cartão com título e ícone, e pares rótulo/valor.
 */
import type { ComponentType, ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/utils/cn'

interface DetailSectionProps {
  title: string
  icon?: ComponentType<{ className?: string }>
  action?: ReactNode
  className?: string
  children: ReactNode
}

export function DetailSection({ title, icon: Icon, action, className, children }: DetailSectionProps) {
  return (
    <Card className={className}>
      <CardHeader className="flex flex-row items-center justify-between gap-2">
        <CardTitle className="flex items-center gap-2">
          {Icon && <Icon className="size-4 text-muted-foreground" aria-hidden="true" />}
          <h2>{title}</h2>
        </CardTitle>
        {action}
      </CardHeader>
      <CardContent className="min-w-0">{children}</CardContent>
    </Card>
  )
}

export function DetailField({ label, children, className }: { label: string; children: ReactNode; className?: string }) {
  return (
    <div className={cn('min-w-0', className)}>
      <dt className="text-xs font-medium text-muted-foreground">{label}</dt>
      <dd className="mt-0.5 break-words text-sm">{children}</dd>
    </div>
  )
}
